import React from 'react'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { appHistory } from '@core/Utils/routing/history'
import { MainContainer } from '@core/Components/Containers'
import type { Campaign } from '@mobi/account/Areas/SignUp'
import { BetOffers } from './Components/BetOffers'
import { getCampaignRaceUrl } from '@mobi/account/Utils'
import { fetchCampaignsAsync } from '@core/State/UserAccount/async-signals'
import { openDeposit } from '@core/Areas/Deposit'

export const BetOfferPage: React.FC = () => {
  React.useEffect(() => {
    fetchCampaignsAsync()
  }, [])

  const handleCampaignClick = (campaign: Campaign) => {
    if (campaign.triggerType === 'AccountDepositTrigger' && campaign.isLive) openDeposit()
    else appHistory.push(getCampaignRaceUrl(campaign))
  }

  return (
    <MainContainer data-tid-bonus-detail-heading background='surface300'>
      <PageHeader title='Bonuses' />
      <BetOffers handleCampaignClick={handleCampaignClick} />
    </MainContainer>
  )
}
